import { render, staticRenderFns } from "./company.vue?vue&type=template&id=c59d4cbc&scoped=true&"
import script from "./company.vue?vue&type=script&lang=js&"
export * from "./company.vue?vue&type=script&lang=js&"
import style0 from "./employ.css?vue&type=style&index=0&id=c59d4cbc&scoped=true&lang=css&"
import style1 from "./company.css?vue&type=style&index=1&id=c59d4cbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c59d4cbc",
  null
  
)

export default component.exports